import _ from 'lodash';

import { collateDuplicateShifts, groupWithoutOverlaps } from '../components/roster-utilities';
import { IRosterBooking, IRosterCustomer, IRosterShift, IRosterWorker } from '../types';

/** Collate/combine duplicate shifts based on serviceDateTimeId, then group overlapping shifts into multiple rows */
export function groupUnassignedShifts(unassignedShifts: IRosterShift[]) {
  return groupWithoutOverlaps(collateDuplicateShifts(unassignedShifts), {
    startDateKey: 'shiftStartDateTime',
    endDateKey: 'shiftEndDateTime',
  });
}

/** Find all assigned shifts for each worker, then group overlapping shifts into multiple rows */
export function groupAssignedShifts(workers: IRosterWorker[], assignedShifts: IRosterShift[]) {
  return workers.map((worker) => ({
    ...worker,
    shifts: groupWithoutOverlaps(
      assignedShifts.filter((shift) => shift.supportWorkerId === worker.supportWorkerId),
      {
        startDateKey: 'shiftStartDateTime',
        endDateKey: 'shiftEndDateTime',
      },
    ),
  }));
}

/** Find all bookings for each customer, then group overlapping bookings into multiple rows */
export function groupBookings(customers: IRosterCustomer[], bookings: IRosterBooking[]) {
  return customers.map((customer) => ({
    ...customer,
    bookings: groupWithoutOverlaps(
      bookings.filter((booking) => booking.bookerUserId === customer.customerId),
      {},
    ),
  }));
}

export function getEarliestSlot(
  unassignedShifts: IRosterShift[],
  assignedShifts: IRosterShift[],
  bookings: IRosterBooking[],
) {
  return _.minBy(
    [
      ..._.map(unassignedShifts, (s) => ({ startDateTime: s.shiftStartDateTime })),
      ..._.map(assignedShifts, (s) => ({ startDateTime: s.shiftStartDateTime })),
      ..._.map(bookings, (s) => ({ startDateTime: s.startDateTime })),
    ],
    (o) => o.startDateTime,
  );
}
